import React, { useCallback } from 'react';
import { useTranslation } from 'localization/useTranslation';
import { Skeleton, TextInput } from '@patternfly/react-core';
import ComponentPropTypes from './ComponentPropTypes';
import styles from './TextComponent.module.css';

const TextComponent = ({ model, value, onChange, hasError, isLoading }) => {
  const T = useTranslation();

  const _onChange = useCallback(value => {
    onChange(model, value);
  }, [model, onChange]);

  const _onBlur = useCallback(() => {
    model?.properties?.onBlur?.();
  }, [model?.properties]);

  return (
    <>
      { isLoading && <Skeleton className={styles.skeleton} /> }
      { !isLoading && <TextInput
        id={model.path}
        placeholder={T.localize(model.placeholder)}
        value={value ?? ''}
        onChange={(_event, textValue) => _onChange(textValue)}
        isDisabled={model.disabled || false}
        validated={hasError ? 'error' : 'default'}
        onBlur={_onBlur}
      />
      }
    </>
  );
};

TextComponent.propTypes = ComponentPropTypes;

export default React.memo(TextComponent);
